import { render, staticRenderFns } from "./Page403.vue?vue&type=template&id=04decec1"
import script from "./Page403.vue?vue&type=script&lang=js"
export * from "./Page403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports